module.exports = __webpack_public_path__ + "img/11-3@2x.cbc0680a.jpg";